import {Action} from '@ngrx/store';
import {BijbError} from '../../../models/bijb-error';

export class AddChecklistItemErrorAction implements Action {
  public static readonly type = 'AddChecklistItemErrorAction';

  constructor(public error: BijbError) {
  }

  public type = AddChecklistItemErrorAction.type;
}

